import { useState } from 'react'

export function coreConsentErrorMessage(cause: unknown): string {
  const error = cause as { code?: unknown; name?: unknown; message?: unknown } | null
  const fingerprint = [error?.code, error?.name, error?.message].map((value) => String(value ?? '')).join(' ').toLowerCase()
  if (fingerprint.includes('appcheck') || fingerprint.includes('app-check') || fingerprint.includes('recaptcha') || fingerprint.includes('attestation') || fingerprint.includes('initial-throttle') || fingerprint.includes('unauthenticated')) {
    return 'This device could not complete secure verification. Close PMM completely, reopen it, then try once more. Reference: PMM-CONSENT-VERIFY.'
  }
  if (fingerprint.includes('network') || fingerprint.includes('unavailable') || fingerprint.includes('failed to fetch')) {
    return 'PMM could not reach the secure service. Check your connection, then try once more. Reference: PMM-CONSENT-NETWORK.'
  }
  return 'Your consent was not recorded, so the private workspace remains closed. Please try once more. Reference: PMM-CONSENT-SERVICE.'
}

export function CoreServiceConsent({ onAccept, onSignOut }: { onAccept(): Promise<void>; onSignOut(): Promise<void> }) {
  const [accepted, setAccepted] = useState(false)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')

  async function continueIntoApp() {
    setBusy(true)
    setError('')
    try {
      await onAccept()
    } catch (cause) {
      setError(coreConsentErrorMessage(cause))
    } finally {
      setBusy(false)
    }
  }

  return (
    <main className="signin-shell">
      <section className="signin-card core-service-card" aria-labelledby="core-service-title">
        <p className="eyebrow">Point-of-collection notice</p>
        <h1 id="core-service-title">Choose what the core service may hold.</h1>
        <p>PMM needs your account identity, approved practice state, your own responses and privacy choices to provide the service. It does not need advertising data, a hidden partner profile or blanket access to private reflections.</p>
        <ul>
          <li>Core records are visible only to your authenticated account and trusted PMM server processes.</li>
          <li>AI, selected reflections, push and persistent offline use remain separate and off by default.</li>
          <li>Withdrawing the required core scope starts account closure rather than silently degrading privacy.</li>
        </ul>
        <label className="core-acceptance"><input type="checkbox" checked={accepted} onChange={(event) => setAccepted(event.target.checked)} /><span>I understand and consent to the required core account and practice records.</span></label>
        {error && <p className="auth-error" role="alert">{error}</p>}
        <button type="button" disabled={!accepted || busy} onClick={() => void continueIntoApp()}>{busy ? 'Recording choice...' : 'Accept and enter privately'}</button>
        <button type="button" className="leave-without-consent" onClick={() => void onSignOut()}>Leave without consenting</button>
      </section>
    </main>
  )
}
